AddPageSwapTrigger(function() {
    if(/^\/live\//.test(document.location.pathname)) {
        swup.cache.remove(document.location.pathname);
    }
    else if($('main#swup').is('.no-cache')) {
        swup.cache.remove(document.location.pathname);
    }
});